import priceFilterComponentHtml from './pricefilter.component.html';
import './pricefilter.component.scss';

class PriceFilterController {
    constructor($scope, $document, $timeout, FullPageLoaderService, SubmitOnChangeService) {
        'ngInject';

        this.$scope = $scope;
        this.$document = $document;
        this.$timeout = $timeout;
        this.fullPageLoaderService = FullPageLoaderService;
        this.SubmitOnChangeService = SubmitOnChangeService;
        this.delayedSubmit = null;
        this.dragging = false;

        this.startCurrentValues = {
            min: this.currentFrom,
            max: this.currentTo
        };
    }

    $onInit() {
        this.form = document.getElementById(this.formId);
        this.startCurrentValues = {
            min: this.currentFrom,
            max: this.currentTo
        };

        if (this.currentFrom != this.minValue || this.currentTo != this.maxValue) {
            this.SubmitOnChangeService.forms.push({
                form: this.form,
                name: `${this.currentFrom}zł - ${this.currentTo}zł`,
                callback: () => {
                    this.currentFrom = '-';
                    this.currentTo = '-';
                    this.instantSubmit();
                }
            });
        }
    }

    $onChanges(changesObj) {
        this.form = document.getElementById(this.formId);
        this.startCurrentValues = {
            min: this.currentFrom,
            max: this.currentTo
        };
    }

    $onDestroy() {
        if (this.delayedSubmit) {
            clearTimeout(this.delayedSubmit);
            this.delayedSubmit = null;
        }
    }

    submit() {
        if (!this.form) return;

        if (this.delayedSubmit) {
            this.$timeout.cancel(this.delayedSubmit);
            this.delayedSubmit = null;
        }

        if (this.currentFrom == this.startCurrentValues.min &&
            this.currentTo == this.startCurrentValues.max) return;

        this.delayedSubmit = this.$timeout(() => {
            this.fullPageLoaderService.show = true;
            this.form.submit();
        }, 1000);
    }

    instantSubmit() {
        if (!this.form) return;

        if (this.delayedSubmit) {
            this.$timeout.cancel(this.delayedSubmit);
            this.delayedSubmit = null;
        }

        this.$timeout(() => {
            this.fullPageLoaderService.show = true;
            this.form.submit();
        }, 1);
    }

    changeMin(minValue) {
        if (minValue < this.minValue) {
            this.currentFrom = this.minValue;
        }

        if (minValue > this.currentTo) {
            this.currentFrom = this.currentTo;
        }

        this.submit();
    }

    changeMax(maxValue) {
        if (maxValue > this.maxValue) {
            this.currentTo = this.maxValue;
        }

        if (maxValue < this.currentFrom) {
            this.currentTo = this.currentFrom;
        }

        this.submit();
    }
}

let priceFilterComponent = {
    bindings: {
        formId: '@',
        minValue: '<',
        maxValue: '<',
        currentFrom: '<',
        currentTo: '<',
    },
    template: priceFilterComponentHtml,
    controller: PriceFilterController
}

export default priceFilterComponent;
